/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocIcon16Light } from './DocIcon16Light';
import { DocIcon16Regular } from './DocIcon16Regular';
import { DocIcon16Solid } from './DocIcon16Solid';
import { DocIcon20Light } from './DocIcon20Light';
import { DocIcon20Regular } from './DocIcon20Regular';
import { DocIcon20Solid } from './DocIcon20Solid';
import { DocIcon24Regular } from './DocIcon24Regular';
import { DocIcon24Solid } from './DocIcon24Solid';
import { DocIcon32Regular } from './DocIcon32Regular';
import { DocIcon64Regular } from './DocIcon64Regular';
var sizes = {
    16: {
        light: DocIcon16Light,
        regular: DocIcon16Regular,
        solid: DocIcon16Solid,
    },
    20: {
        light: DocIcon20Light,
        regular: DocIcon20Regular,
        solid: DocIcon20Solid,
    },
    24: {
        regular: DocIcon24Regular,
        solid: DocIcon24Solid,
    },
    32: {
        regular: DocIcon32Regular,
    },
    64: {
        regular: DocIcon64Regular,
    },
};
export var DocIcon = forwardRef('DocIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
